var map = {
	"./2560@3x.png": 1863,
	"./Big_plus_svg.svg": 805,
	"./Facebook.png": 472,
	"./Google.png": 471,
	"./Header_logo.png": 476,
	"./Information-icon.png": 1864,
	"./Instagram.png": 1865,
	"./Payment_icon.png": 806,
	"./Seller_terms.png": 807,
	"./Success_black_png.png": 808,
	"./abstract_thumb.jpg": 310,
	"./acrylic.jpg": 174,
	"./acrylic_thumb.png": 1866,
	"./android_app.png": 470,
	"./appreciate_icon.png": 809,
	"./approve_ship.png": 810,
	"./arrow-down-static.png": 1867,
	"./arrow_svg.svg": 168,
	"./artist_banner.png": 287,
	"./artist_profilepic.png": 233,
	"./artist_profilepic1.png": 1868,
	"./artistic.jpg": 311,
	"./artwork_bg.png": 941,
	"./artwork_image.png": 286,
	"./artwork_picture.png": 477,
	"./banner_hts.png": 1869,
	"./bedroom.svg": 942,
	"./bedroom_banner.jpg": 1870,
	"./bedroom_thumb.jpg": 234,
	"./black_heart_png.png": 811,
	"./black_menu_icon.png": 1871,
	"./blacknwhite.jpg": 312,
	"./botanicals.jpg": 313,
	"./burger-menu-icon.png": 812,
	"./buy_icon.png": 813,
	"./buyrequest_icon.png": 814,
	"./cafe_banner.jpg": 1872,
	"./cafe_thumb.jpg": 235,
	"./cash_icon.png": 478,
	"./charcoal.jpg": 236,
	"./charcoal_thumb.png": 1873,
	"./checked.png": 167,
	"./checked_icon_gold.png": 1874,
	"./checked_interest.png": 216,
	"./collect_icon.png": 815,
	"./colorful_banner.jpg": 1875,
	"./colorful_thumb.jpg": 816,
	"./connect_icon.png": 817,
	"./contemporary_banner.jpg": 1876,
	"./contemporary_thumb.jpg": 818,
	"./cover-photo.png": 1877,
	"./credits_icon.png": 479,
	"./cross.png": 302,
	"./cross_icon_for_close.png": 31,
	"./default_banner.png": 1878,
	"./default_picture.png": 83,
	"./default_square_picture.png": 143,
	"./delete_icon_svg.svg": 819,
	"./down_arrow.png": 417,
	"./emerge_icon.png": 820,
	"./favicon.png": 1879,
	"./figures_banner.jpg": 1880,
	"./figures_thumb.jpg": 821,
	"./footer_appstore.svg": 798,
	"./footer_logo_png.png": 796,
	"./footer_playstore.svg": 797,
	"./graphite.jpg": 218,
	"./graphite_.jpg": 1881,
	"./graphite_thumb.png": 1882,
	"./hamburger.png": 1883,
	"./heart copy 2_svg (2).svg": 702,
	"./heart copy 2_svg.svg": 703,
	"./heart-black.png": 1884,
	"./heart_filled@2x.png": 822,
	"./heart_icon.png": 419,
	"./heart_icon_outline.png": 420,
	"./hide-password.png": 467,
	"./home_images.png": 823,
	"./hospital_banner.jpg": 1885,
	"./hospital_thumb.jpg": 824,
	"./hotel_banner.jpg": 1886,
	"./hotel_thumb.jpg": 825,
	"./ink.jpg": 220,
	"./ios_app.png": 469,
	"./jan.jpg": 1887,
	"./kids_room.jpg": 1888,
	"./kitchen_banner.jpg": 1889,
	"./kitchen_thumb.jpg": 826,
	"./landscape_banner.jpg": 1890,
	"./landscape_thumb.jpg": 314,
	"./living_room.svg": 1891,
	"./livingroom_banner.jpg": 1892,
	"./livingroom_thumb.jpg": 237,
	"./location.png": 232,
	"./login_image.png": 1427,
	"./login_image2.png": 1893,
	"./logo.png": 1894,
	"./maximalism.jpg": 315,
	"./mixed.jpg": 175,
	"./new_notification_icon_svg.svg": 827,
	"./notification_icon copy_svg.svg": 244,
	"./notification_icon_svg.svg": 828,
	"./office_banner.jpg": 1895,
	"./office_thumb.jpg": 238,
	"./oil.jpg": 123,
	"./oil_.jpg": 1896,
	"./oil_thumb.png": 447,
	"./others.jpg": 1897,
	"./outdoor_banner.jpg": 1898,
	"./outdoor_thumb.jpg": 829,
	"./painting1.png": 107,
	"./painting2.png": 64,
	"./painting3.png": 126,
	"./pastels.jpg": 219,
	"./pastels_.jpg": 1899,
	"./patterns_banner.jpg": 1900,
	"./patterns_thumb.jpg": 830,
	"./payment_icons.png": 799,
	"./pencil.jpg": 217,
	"./pencil_thumb.png": 1901,
	"./pick_photo_tap_svg.svg": 301,
	"./platform_banner.png": 1902,
	"./portrait_banner.jpg": 1903,
	"./portraits_thumb.jpg": 316,
	"./profile-picture.png": 1904,
	"./quazi.jpg": 1905,
	"./redHeart.svg": 1906,
	"./request_process_icon.png": 831,
	"./restaurant_banner.jpg": 1907,
	"./restaurant_thumb.jpg": 832,
	"./right_arrow_tap.png": 1908,
	"./search_icon.png": 480,
	"./ship_icon.png": 833,
	"./show-password.png": 468,
	"./showcase_icon.png": 834,
	"./success-icon.png": 303,
	"./success_gold_png.png": 184,
	"./surrealism_banner.jpg": 1909,
	"./surrealism_thumb.jpg": 835,
	"./traditional_banneer.jpg": 1910,
	"./traditional_thumb.jpg": 836,
	"./unchecked.png": 166,
	"./unchecked_interest.png": 215,
	"./unckecked_gray_icon.png": 1911,
	"./upload_art.png": 837,
	"./upload_icon_big.svg": 838,
	"./upload_icon_png.png": 839,
	"./upload_icon_svg.svg": 423,
	"./verified_svg.svg": 840,
	"./watercolor.jpg": 173,
	"./watercolor_category.png": 841,
	"./watercolor_thumb.png": 1912,
	"./white_cross.png": 1913
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1862;


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = 1862
// module chunks = 0